<template>
  <button
    :class="`commonLanguage commonLanguage_${currentLang}`"
    @click="toggle"
  >
    {{ currentLang }}
  </button>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TheLanguage",
  data() {
    return {
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(","),
    };
  },
  computed: {
    ...mapGetters({
      showLangSwitcher: "showLangSwitcher",
    }),
    currentLang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapMutations({
      TOGGLE_LANG_SWITCHER: "TOGGLE_LANG_SWITCHER",
    }),
    toggle() {
      this.TOGGLE_LANG_SWITCHER(!this.showLangSwitcher);
    },
  },
};
</script>

<style lang="scss">
.commonLanguage {
  width: 20px;
  height: 15px;
  padding: 0;
  border: 0;
  background-repeat: no-repeat;
  background-position: center right;
  font-size: 0;
  background-size: 20px 15px;
  border: none;
  background-color: transparent;
  right: 20px;

  &_en {
    background-image: url("@/icons/flags/en.svg");
  }

  &_ru {
    background-image: url("@/icons/flags/ru.svg");
  }
  &_ar {
    background-image: url("@/icons/flags/ar.svg");
  }
  &_hr {
    background-image: url("@/icons/flags/hr.svg");
  }
  &_bg {
    background-image: url("@/icons/flags/bg.svg");
  }
  &_de {
    background-image: url("@/icons/flags/de.svg");
  }
  &_es {
    background-image: url("@/icons/flags/es.svg");
  }
  &_hu {
    background-image: url("@/icons/flags/hu.svg");
  }
  &_it {
    background-image: url("@/icons/flags/it.svg");
  }
  &_nl {
    background-image: url("@/icons/flags/nl.svg");
  }
  &_sk {
    background-image: url("@/icons/flags/sk.svg");
  }
  &_sl {
    background-image: url("@/icons/flags/sl.svg");
  }
  &_el {
    background-image: url("@/icons/flags/el.svg");
  }
  &_pt {
    background-image: url("@/icons/flags/pt.svg");
  }
  &_no {
    background-image: url("@/icons/flags/no.svg");
  }
  &_hy {
    background-image: url("@/icons/flags/hy.svg");
  }
}
</style>
